<template>
    <validation-observer ref="generalDealer">
         <b-form class="formBox">  
              <validation-provider :name="$t('dealer.wizzard.title')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('dealer.wizzard.title')" label-for="title">
                        <b-form-input
                            id="title"
                            v-model="generalDealer.name"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

              <validation-provider :name="$t('dealer.wizzard.companyType')" :rules="{ required: true, is_not:0 }" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('dealer.wizzard.companyType')" label-for="companyType">
                        <div class="elements">
                            <Multiselect  
                                v-model="compType"
                                :show-labels="false" 
                                :options="compTypes"
                                @input="setCompanyType"
                                label="name"
                                track-by="id" >
                                    <template slot="singleLabel" slot-scope="{ option }">
                                        <strong>{{ option.name }} </strong> 
                                    </template>
                            </Multiselect>
                        </div>
                        <b-form-invalid-feedback id="live-feedback" style="display:block">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

              <validation-provider :name="$t('dealer.wizzard.authPerson')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('dealer.wizzard.authPerson')" label-for="auth">
                        <b-form-input
                            id="auth"
                            v-model="generalDealer.authPerson"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

             <validation-provider :name="$t('dealer.wizzard.phoneNo')" :rules="{ required: true, regex: /^(\+\s\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ }" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('dealer.wizzard.phoneNo')" label-for="phone">
                        <MaskedInput
                            id="phone"
                            v-model="generalDealer.phone"
                            mask="\+\ 11 (111) 111 1111"
                            placeholder="Phone number"
                            type="tel" 
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"/>
                        <b-form-invalid-feedback style="display:none" id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>
              
              <validation-provider v-if="!data" :name="$t('dealer.wizzard.taxNo')" :rules="{ required: true, digits:10}" v-slot="validationContext">
                    <b-form-group class="inputGrp"  :label="$t('dealer.wizzard.taxNo')" label-for="taxNumber">
                        <b-form-input
                            id="taxNumber"
                            v-model="generalDealer.taxNumber"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

               <validation-provider v-if="!data" :name="$t('dealer.wizzard.taxAdmin')" :rules="{ required: true, min:3}" v-slot="validationContext">
                    <b-form-group class="inputGrp"  :label="$t('dealer.wizzard.taxAdmin')" label-for="taxAdmin">
                        <b-form-input
                            id="taxNumber"
                            v-model="generalDealer.taxAdmin"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

              <validation-provider v-if="!data" :name="$t('dealer.wizzard.faxNo')" :rules="{ required: false, digits:11}" v-slot="validationContext">
                    <b-form-group class="inputGrp"  :label="$t('dealer.wizzard.faxNo')" label-for="faxNo">
                        <b-form-input
                            id="faxNo"
                            v-model="generalDealer.faxNo"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

               <validation-provider v-if="!data" :name="$t('dealer.wizzard.postCode')" :rules="{ required: false, digits: 6}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('dealer.wizzard.postCode')" label-for="postCode">
                        <b-form-input
                            id="postCode"
                            v-model="generalDealer.postCode"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

              
              <validation-provider v-if="!data" :name="$t('general.country')" :rules="{ required: true, is_not:0 }" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('general.country')" label-for="country">
                        <div class="elements">
                            <Multiselect  
                                v-model="country"
                                :show-labels="false" 
                                :options="countries"
                                @input="setCountry"
                                label="name"
                                track-by="country_id" >
                                    <template slot="singleLabel" slot-scope="{ option }">
                                        <strong>{{ option.name }} </strong> 
                                    </template>
                            </Multiselect>
                            
                            <b-button size="sm" variant="primary" :title="$t('general.newCountry')"  @click="openModal('country')"> <b-icon icon="plus" /> </b-button>
                        </div>
                        <b-form-invalid-feedback id="live-feedback" style="display:block">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

              <validation-provider v-if="!data" :name="$t('general.city')" :rules="{ required: true, is_not:0 }" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('general.city')" label-for="city">
                        <div class="elements">
                             <Multiselect  
                                v-model="city"
                                :show-labels="false" 
                                :options="cities"
                                @input="setCity"
                                label="name"
                                track-by="city_id" >
                                    <template slot="singleLabel" slot-scope="{ option }">
                                        <strong>{{ option.name }} </strong> 
                                    </template>
                            </Multiselect>
                            <b-button size="sm" variant="primary" :title="$t('general.newCity')" @click="openModal('city')"> <b-icon icon="plus" /> </b-button>
                        </div>
                        <b-form-invalid-feedback id="live-feedback" style="display:block">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

              <validation-provider v-if="!data" :name="$t('general.district')" :rules="{ required: true, is_not:0}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('general.district')" label-for="district">
                        <div class="elements">
                             <Multiselect  
                                v-model="district"
                                :show-labels="false" 
                                :options="towns"
                                @input="setDistrict"
                                label="name"
                                track-by="town_id" >
                                    <template slot="singleLabel" slot-scope="{ option }">
                                        <strong>{{ option.name }} </strong> 
                                    </template>
                            </Multiselect>
                            <b-button size="sm" variant="primary" :title="$t('general.newDistrict')" @click="openModal('town')"> <b-icon icon="plus" /> </b-button>
                        </div>
                        <b-form-invalid-feedback id="live-feedback" style="display:block">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

              <validation-provider v-if="!data" :name="$t('general.address')" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('general.address')" label-for="address">
                        <div class="elements">
                            <b-form-textarea 
                                id="address"
                                rows="3"
                                v-model="generalDealer.address"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                            ></b-form-textarea>
                        </div>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>

         </b-form>
        </validation-observer>
</template>
               
<script>
    import MaskedInput from 'vue-masked-input';
    import Multiselect from 'vue-multiselect'


    export default {
        name: "GeneralForm",
        components:{
            Multiselect, MaskedInput
        },
        computed: {
            countries(){
                return this.$store.getters.getCountries
            },
            cities(){
                return this.$store.getters.getCities
            },
            towns(){
                return this.$store.getters.getTowns
            },
            compTypes(){
                return this.$store.getters.getCompanyTypes
            }
        },
        data: function(){
            return{
                generalDealer:{
                    name: this.data && Object.keys(this.data).length > 0 ? this.data.name : "" ,
                    taxNumber: "",
                    taxAdmin:  "",
                    phone: this.data && Object.keys(this.data).length > 0 ? this.data.phone_no : "",
                    address: "",
                    faxNo: "",
                    postCode: "",
                    authPerson: this.data && Object.keys(this.data).length > 0 ? this.data.auth_person_name : "",
                    country:  0,
                    city: 0,
                    district:  0,     
                    compType: this.data && Object.keys(this.data).length > 0 ? this.data.comp_type.id : 0
                },
                country:  0,
                city:  0,
                district:  0,     
                compType: this.data && Object.keys(this.data).length > 0 ? this.data.comp_type : 0

            }
        },
        props:{
            data: Object,
            modalEvent: Function,
            pageSettings: Function,
        },
        watch:{
            country:function(){
                this.$store.dispatch('city_list', [this.generalDealer.country])
                this.generalDealer.city = 0
            },
            city:function(){
                this.$store.dispatch('district_list', [this.generalDealer.country, this.generalDealer.city])
                this.generalDealer.district = 0
            },
           
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            setCountry(val){
                this.generalDealer.country = val.country_id
            },
            setCity(val){
                this.generalDealer.city = val.city_id
            },
            setDistrict(val){
                this.generalDealer.district = val.town_id
            },
            setCompanyType(val){
                this.generalDealer.compType = val.id
            },
            openModal(type){
                let params = {type};
                switch(type){
                    case 'city':
                        params.country_id= this.generalDealer.country
                        break;
                    case 'town':
                        params.country_id= this.generalDealer.country
                        params.city_id= this.generalDealer.city
                }
                this.modalEvent(true,'add', params)
            }
        },

    }
</script>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/components/GeneralForm.vue